import { createEventPropertiesFromSegmentRules, getEventPropertyFilters } from '@utils/segments.js';

function hasRules ({ segment, rule } = {}) {
    const { definition } = segment;
    const filters = definition.filters.reduce((set, filter) => {
        if (filter.or) {
            filter.or.forEach((filter) => set.add(filter.kind));
        } else {
            set.add(filter.kind);
        }

        return set;
    }, new Set());

    return filters.has(rule);
}

export function hasVisitorRules (segment) {
    const { definition } = segment;

    return !definition.filters.length || hasRules({ segment, rule: 'visitor' });
}

export function hasAccountRules (segment) {
    return hasRules({ segment, rule: 'account' });
}

export function hasParentAccountRules (segment) {
    return hasRules({ segment, rule: 'parentAccount' });
}

export function filtersHaveRulesOfKind (filters = [], kind) {
    return filters.some((filter) => filter && (filter.or ? filter.or.some((rule) => rule.kind === kind) : filter.kind === kind));
}

export function sendSaveSegmentTrackEvents (savedSegment, options = {}) {
    const { action = 'create', location = '' } = options;
    const eps = createEventPropertiesFromSegmentRules(savedSegment);

    window.pendo.track('Save Segment', {
        action,
        ...(location ? { location } : {}),
        segmentId: savedSegment.id,
        isShared: savedSegment.shared,
        hasDescription: !!savedSegment.description,
        ...eps,
    });

    if (eps.hasFilterTypes.includes('historicalMetadata')) {
        const historicalFilters = getEventPropertyFilters(savedSegment, 'historicalMetadata').reduce(
            (acc, filter) => {
                acc.kinds.add(filter.eventPropertyKind);
                acc.groups.add(filter.eventPropertyGroup);

                return acc;
            },
            { kinds: new Set(), groups: new Set() },
        );

        window.pendo.track('Run Historical Metadata', {
            productAreas: 'Segment',
            hasSegment: false,
            hasFilter: eps.hasFilter,
            hasGroupBy: false,
            metadataKind: Array.from(historicalFilters.kinds)
                .sort()
                .toString(),
            metadataGroup: Array.from(historicalFilters.groups)
                .sort()
                .toString(),
        });
    }
}
